<script>
import formStepMixin from '@phoenix/mixins/formStepMixin';
import FormGroup from '@maison/components/form/FormGroup.vue';
import TextField from '@maison/components/form/fields/TextField.vue';
import StateField from '@phoenix/components/form/fields/StateField.vue';

export default {
  components: {
    FormGroup,
    TextField,
    StateField,
  },

  mixins: [formStepMixin],
};
</script>

<template>
  <div>
    <legend class="sr-only">{{ $t(`Form.gep.step2.label`) }}</legend>

    <h5 class="mb-8">{{ $t(`Form.gep.step2.title`) }}</h5>

    <div class="flex-grid flex-grid--y--md">
      <div v-if="fieldIsPresent('address9')" class="w-full">
        <form-group :attrs="fields.address9">
          <state-field v-model="fields.address9.value" :empty-choice="false" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('salesforceDistrict')" class="w-full">
        <form-group :attrs="fields.salesforceDistrict">
          <state-field v-model="fields.salesforceDistrict.value" :empty-choice="false" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('zip')" class="w-full">
        <form-group :attrs="fields.zip">
          <text-field v-model="fields.zip.value" />
        </form-group>
      </div>

      <div v-if="fieldIsPresent('address7')" class="w-full">
        <form-group :attrs="fields.address7">
          <text-field v-model="fields.address7.value" />
        </form-group>
      </div>
    </div>
  </div>
</template>
